import {Component, computed, effect, model, OnDestroy, Signal} from '@angular/core';
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {AlertService} from "../../../../common/alert/alert.service";
import {AlertComponent} from "../../../../common/alert/alert.component";
import {toSignal} from "@angular/core/rxjs-interop";
import {NgForOf, NgIf} from "@angular/common";
import {Batch, PinholePromoCodeService, PromoCodeCategory, Statistic} from "../../services/pinhole.promo-code.service";

@Component({
    selector: 'report',
    templateUrl: './report.component.html',
    imports: [
        ReactiveFormsModule,
        AlertComponent,
        NgForOf,
        NgIf
    ],
    styleUrls: ['report.component.css'],
    providers: [AlertService]
})
export class ReportComponent implements OnDestroy {
    private statisticFormBuilder = new FormBuilder().nonNullable
    private category = this.statisticFormBuilder.control("")
    private batch = this.statisticFormBuilder.control("")
    private subscriptions: Subscription[] = [];
    private categorySignal = toSignal(this.category.valueChanges);

    isLoading: boolean = false;
    statisticForm = new FormGroup({
        category: this.category,
        batch: this.batch,
    });

    readonly statistic = model<Statistic | null>(null);
    readonly categoryToBatch = model<Map<PromoCodeCategory, Batch[]> | null>(null);
    readonly promoCodeCategories = model<PromoCodeCategory | null>(null);
    batches: Signal<(Batch[] | undefined)> = computed(() => {
        if (this.categorySignal() && this.categoryToBatch()) {
            return this.categoryToBatch()?.get(this.categorySignal()!);
        }
        return [];
    })

    constructor(private service: PinholePromoCodeService, private alertService: AlertService) {
        if (!this.category.value) {
            this.batch.disable();
        }

        this.loadCategories();
        this.loadBatches();

        effect(() => {
            if (this.categorySignal()) {
                this.batch.enable();
            } else {
                this.batch.disable();
            }
        })
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    loadCategories() {
        this.alertService.clearAlerts();
        this.subscriptions.push(
            this.service
                .getCategories()
                .subscribe(value => {
                    if (value != null) {
                        this.promoCodeCategories.set(value);
                    }
                })
        );
    }

    loadBatches() {
        this.alertService.clearAlerts();
        this.subscriptions.push(
            this.service
                .getBatches()
                .subscribe(value => {
                    if (value != null) {
                        this.categoryToBatch.set(value);
                    }
                })
        );
    }

    findStatistic() {
        this.alertService.clearAlerts();
        this.isLoading = true;
        this.statistic.set(null);
        this.subscriptions.push(
            this.service
                .getStatistic({
                    category: this.category.value,
                    batch: this.batch.value
                })
                .subscribe(value => {
                    this.isLoading = false;
                    if (value != null) {
                        this.statistic.set(value);
                    } else {
                        this.alertService.showAlert('danger', "Not found");
                    }
                })
        );
    }
}
